import { makeStyles } from '@mui/styles';
import React from 'react';
import MarkdownView from 'react-showdown';

interface MarkdownConversionCellRendererProps {
    value: string;
}

const muiStyles = makeStyles({ root: { lineHeight: '20px' }});

export const MarkdownConversionCellRenderer = (props: MarkdownConversionCellRendererProps) => {
    const { root } = muiStyles(props);

    return (
        <MarkdownView
            className={root}
            markdown={props?.value}
        />
    );
};